import {
  type CreateIntercityOrderResponse,
  createIntercityOrderFn,
  type DefaultQueryError,
  type CreateIntercityOrderRequestBody,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export const useCreateIntercityOrder = (
  opts?: UseMutationOptions<
    CreateIntercityOrderResponse,
    DefaultQueryError,
    CreateIntercityOrderRequestBody
  >
) =>
  useMutation<
    CreateIntercityOrderResponse,
    DefaultQueryError,
    CreateIntercityOrderRequestBody
  >({
    mutationFn: createIntercityOrderFn,
    ...opts,
  });
